define(
    'providers/dataprovider.templatelibraries',[
        "services/config"
    ],
    function(config) {

        function getCategories() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-templatelibraries-categories",
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getTemplatesByCategoryId(categoryId) {
            var data = { categoryId: categoryId };
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-templatelibraries-templatesbycategoryid",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getTemplateDetailById(id) {
            var data = { id: id };
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-templatelibraries-templatedetailbyid",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        init();

        return {
            getCategories: getCategories,
            getTemplatesByCategoryId: getTemplatesByCategoryId,
            getTemplateDetailById: getTemplateDetailById
        };

        //#region Internal Methods

        function init() {

            amplify.request.define("get-templatelibraries-categories", "ajax", {
                url: getUrl("admin/librarytemplates/categories"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-templatelibraries-templatesbycategoryid", "ajax", {
                url: getUrl("admin/librarytemplates/list/{categoryId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-templatelibraries-templatedetailbyid", "ajax", {
                url: getUrl("admin/librarytemplates/{id}"),
                dataType: "json",
                type: "GET"
            });
        }

        function getUrl(action) {
            return config.webApiUrl + action;
        }

        //#endregion
    }
);
